import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
/* eslint-disable react/prop-types */
import React from 'react';
import { compose, withProps, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import ReactTable, { LoadingComponent, selectTableHOC } from "../../Table";
import { getRequirementTemplateListAction } from "../../../api/jsonapi";
import lazyLoad from "../../../util/lazyLoad";
import withPropsOnChangeDebounce from "../../enhancers/withPropsOnChangeDebounce";
import StageName from "../../StageName";
import CategoryName from "../../CategoryName";
import { Classifications } from "../../../data";
var EnhancedTable = selectTableHOC('id')(ReactTable);
var getSortFromArray = function getSortFromArray(sortingBy) {
  var label = 'id';
  if (sortingBy && sortingBy.length) {
    label = sortingBy[0].id;
    if (sortingBy[0].desc) {
      label = "-".concat(label);
    }
  }
  return label;
};
var getClassificationFilter = function getClassificationFilter(tab, currentTab) {
  if (tab && ['actions', 'applicant requirements'].includes(tab.toLowerCase())) {
    if (currentTab === 'actions') {
      return "".concat(Classifications.ACTION_REQUIREMENTS, ",").concat(Classifications.SCHOOL_REQUIREMENTS);
    }
    return Classifications.APPLICANT_REQUIREMENTS;
  }
  return null;
};
var columns = [{
  Header: 'Requirement',
  id: 'id',
  accessor: function accessor(d) {
    return "".concat(d.id, ": ").concat(d.attributes.internal_title);
  }
}, {
  Header: 'Description',
  id: 'internal_description',
  accessor: function accessor(d) {
    return d.attributes.internal_description;
  }
}, {
  Header: 'Category',
  id: 'requirement_category_id',
  sortable: false,
  accessor: function accessor(d) {
    return /*#__PURE__*/React.createElement(CategoryName, {
      name: d.attributes.requirement_category
    });
  }
}, {
  Header: 'Stage',
  id: 'application_stage_id',
  sortable: false,
  accessor: function accessor(d) {
    return /*#__PURE__*/React.createElement(StageName, {
      name: d.attributes.application_stage
    });
  }
}];
var enhancer = compose(connect(function (state) {
  var _state$application, _state$application$cu;
  return {
    currentTab: state === null || state === void 0 ? void 0 : (_state$application = state.application) === null || _state$application === void 0 ? void 0 : (_state$application$cu = _state$application.currentTab) === null || _state$application$cu === void 0 ? void 0 : _state$application$cu.toLowerCase(),
    tab: state && state.application && state.application.currentTab
  };
}), withPropsOnChangeDebounce(200, function (oldProps, nextProps) {
  var _oldProps$filters$req, _oldProps$filters, _nextProps$filters$re, _nextProps$filters;
  var old_requirement_id = (_oldProps$filters$req = oldProps === null || oldProps === void 0 ? void 0 : (_oldProps$filters = oldProps.filters) === null || _oldProps$filters === void 0 ? void 0 : _oldProps$filters.requirement_id) !== null && _oldProps$filters$req !== void 0 ? _oldProps$filters$req : '';
  var next_requirement_id = (_nextProps$filters$re = nextProps === null || nextProps === void 0 ? void 0 : (_nextProps$filters = nextProps.filters) === null || _nextProps$filters === void 0 ? void 0 : _nextProps$filters.requirement_id) !== null && _nextProps$filters$re !== void 0 ? _nextProps$filters$re : '';
  return old_requirement_id !== next_requirement_id;
}, function (_ref) {
  var _filters$requirement_;
  var filters = _ref.filters;
  var requirement_id = (_filters$requirement_ = filters === null || filters === void 0 ? void 0 : filters.requirement_id) !== null && _filters$requirement_ !== void 0 ? _filters$requirement_ : '';
  return {
    requirement_id: requirement_id
  };
}), lazyLoad('api_requirements_templates_list', getRequirementTemplateListAction, function (perform, _ref2) {
  var _ref2$filters = _ref2.filters,
    application_stage = _ref2$filters.application_stage,
    requirement_category = _ref2$filters.requirement_category,
    requirement_id = _ref2.requirement_id,
    pageNumber = _ref2.pageNumber,
    pageSize = _ref2.pageSize,
    sortingBy = _ref2.sortingBy,
    activeOnly = _ref2.activeOnly,
    currentTab = _ref2.currentTab,
    tab = _ref2.tab;
  return perform({
    'filter[application_stage]': application_stage === null || application_stage === void 0 ? void 0 : application_stage.value,
    'filter[requirement_category]': requirement_category === null || requirement_category === void 0 ? void 0 : requirement_category.value,
    'page[number]': pageNumber + 1,
    'page[size]': pageSize,
    sort: getSortFromArray(sortingBy),
    'stats[total]': 'count',
    'filter[q]': requirement_id || null,
    'filter[active]': activeOnly ? 'true' : null,
    'filter[classification]': getClassificationFilter(tab, currentTab)
  });
}, function (_ref3) {
  var request = _ref3.request;
  return !request || !request.hasStarted;
}), withProps(function (_ref4) {
  var status = _ref4.status;
  return {
    loading: !status || !status.api_requirements_templates_list || !status.api_requirements_templates_list.hasStarted || status.api_requirements_templates_list.isLoading
  };
}), withHandlers({
  TrPropsHandler: function TrPropsHandler(_ref5) {
    var isSelected = _ref5.isSelected,
      selectedRowClassName = _ref5.selectedRowClassName;
    return function (_state, rowInfo) {
      return isSelected && rowInfo && selectedRowClassName && isSelected(rowInfo.row._original.id) ? {
        className: selectedRowClassName
      } : {};
    };
  }
}));
var resolveData = function resolveData(data) {
  return data || [];
};
var RequirementsTable = function RequirementsTable(_ref6) {
  var _status$api_requireme, _status$api_requireme2, _status$api_requireme3, _status$api_requireme4, _status$api_requireme5;
  var api_requirements_templates_list = _ref6.api_requirements_templates_list,
    isSelected = _ref6.isSelected,
    toggleSelection = _ref6.toggleSelection,
    loading = _ref6.loading,
    TrPropsHandler = _ref6.TrPropsHandler,
    _ref6$pageNumber = _ref6.pageNumber,
    pageNumber = _ref6$pageNumber === void 0 ? 0 : _ref6$pageNumber,
    _ref6$pageSize = _ref6.pageSize,
    pageSize = _ref6$pageSize === void 0 ? 20 : _ref6$pageSize,
    _ref6$sortingBy = _ref6.sortingBy,
    sortingBy = _ref6$sortingBy === void 0 ? [{
      id: 'id',
      desc: false
    }] : _ref6$sortingBy,
    status = _ref6.status,
    onPageChange = _ref6.onPageChange,
    onPageSizeChange = _ref6.onPageSizeChange,
    onSortedChange = _ref6.onSortedChange;
  return /*#__PURE__*/React.createElement(EnhancedTable, {
    selectType: "checkbox",
    columns: columns,
    data: api_requirements_templates_list,
    resolveData: resolveData,
    isSelected: isSelected,
    toggleSelection: toggleSelection,
    loading: loading,
    LoadingComponent: LoadingComponent,
    getTrProps: TrPropsHandler,
    page: pageNumber,
    pages: Math.ceil(((_status$api_requireme = status === null || status === void 0 ? void 0 : (_status$api_requireme2 = status.api_requirements_templates_list) === null || _status$api_requireme2 === void 0 ? void 0 : (_status$api_requireme3 = _status$api_requireme2.meta) === null || _status$api_requireme3 === void 0 ? void 0 : (_status$api_requireme4 = _status$api_requireme3.stats) === null || _status$api_requireme4 === void 0 ? void 0 : (_status$api_requireme5 = _status$api_requireme4.total) === null || _status$api_requireme5 === void 0 ? void 0 : _status$api_requireme5.count) !== null && _status$api_requireme !== void 0 ? _status$api_requireme : 0) / pageSize),
    pageSize: pageSize,
    sorted: sortingBy,
    onPageChange: onPageChange,
    onPageSizeChange: onPageSizeChange,
    onSortedChange: onSortedChange,
    manual: true
  });
};
var EnhancedRequirementsTable = enhancer(RequirementsTable);
EnhancedRequirementsTable.defaultProps = {
  filters: {}
};
export default EnhancedRequirementsTable;